import axios from "axios";
// import store from '../store'
import Cookie from "js-cookie";


const baseUrl = '/api';

const api = axios.create({
 baseURL: baseUrl,
});


api.interceptors.request.use(
  
    (request) => {
      // const token = store.getters['auth/token']

      // const token = Cookie.get('token');
      const token = localStorage.getItem('token');

      if (token) {
        request.headers.common.Authorization = `Bearer ${token}`
        
      }
   
      return request;
    },
    (error) => {
      return Promise.reject(error);
    }
);


export default api